import React, { useState } from 'react';

// Copertura SSMATE con lo STESSO layout della PWA agente (multitab RIEPILOGO/FWA/PACCHETTI/PROFILI,
// RIEPILOGO a gruppi con le sole tecnologie vendibili), in veste desktop scura. Usa d.colonne se
// presente, altrimenti ricostruisce le colonne OK dalla stringa d.esito.
const COLS = [
  { k: 'fwa_5g', l: 'FWA 5G', t: 'ok' }, { k: 'fwa_4g', l: 'FWA 4G', t: 'ok' },
  { k: 'fibra_10g', l: 'Fibra 10G', t: 'ok' }, { k: 'fibra_nere', l: 'Fibra nere', t: 'ok' },
  { k: 'fibra_bianche', l: 'Fibra bianche', t: 'ok' }, { k: 'xdsl_30m', l: 'xDSL 30M', t: 'speed' },
  { k: 'xdsl_fast200', l: 'xDSL Fast 200', t: 'speed' }, { k: 'adsl_prof', l: 'ADSL Prof.', t: 'ok' },
  { k: 'ftto', l: 'FTTO', t: 'fascia' }, { k: 'eth_silver', l: 'Eth. Silver', t: 'fascia' },
  { k: 'eth_gold', l: 'Eth. Gold', t: 'fascia' }, { k: 'fibra_prof_10g', l: 'Fibra Prof. 10G', t: 'ok' },
  { k: 'fibra_prof', l: 'Fibra Prof.', t: 'ok' },
];
const TABS = [
  { id: 'RIEPILOGO' },
  { id: 'FWA', keys: ['fwa_5g', 'fwa_4g'] },
  { id: 'PACCHETTI', keys: ['fibra_10g', 'fibra_nere', 'fibra_bianche'] },
  { id: 'PROFILI', keys: ['fibra_prof_10g', 'fibra_prof', 'xdsl_30m', 'xdsl_fast200', 'adsl_prof', 'ftto', 'eth_silver', 'eth_gold'] },
];
const RIEP_GRUPPI = [
  { id: 'FWA', keys: ['fwa_5g', 'fwa_4g'] },
  { id: 'PACCHETTI', keys: ['fibra_10g', 'fibra_nere', 'fibra_bianche'] },
  { id: 'PROFILI', keys: ['fibra_prof_10g', 'fibra_prof', 'xdsl_30m', 'xdsl_fast200', 'adsl_prof'] },
  { id: 'DEDICATA', keys: ['ftto', 'eth_silver', 'eth_gold'] },
];
const LABEL = Object.fromEntries(COLS.map((c) => [c.k, c.l]));
function colonneDaEsito(esito) {
  const s = (esito || '').toUpperCase();
  const col = {};
  COLS.forEach((c) => { col[c.k] = { esito: s.includes(c.l.toUpperCase()) ? 'OK' : null }; });
  return col;
}
function covStato(d) {
  if (d?.errore) return 'errore';
  const e = (d?.esito || '').trim().toLowerCase();
  if (e === 'errore') return 'errore';
  if (d?.trovato === false || e === 'non trovato') return 'nontrovato';
  return 'ok';
}
const Check = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
);
function cell(c, v) {
  v = v || {};
  if (c.t === 'ok') return v.esito === 'OK' ? <Check /> : (v.esito === 'GIALLO' ? <span style={{ color: '#f59e0b' }}>~</span> : <span style={{ color: 'rgba(255,255,255,.3)' }}>—</span>);
  if (c.t === 'speed') return (v.esito === 'OK' && (v.up || v.down)) ? <span style={{ color: '#fff' }}>{v.up || '?'}/{v.down || '?'}</span> : <span style={{ color: 'rgba(255,255,255,.3)' }}>—</span>;
  return <span style={{ color: v.fascia || v.esito === 'OK' ? '#fff' : 'rgba(255,255,255,.3)' }}>{v.fascia || (v.esito === 'OK' ? 'OK' : '—')}</span>;
}

export default function CoperturaMatrice({ d }) {
  const [tab, setTab] = useState('RIEPILOGO');
  if (!d) return null;
  const colonne = (d.colonne && Object.keys(d.colonne).length) ? d.colonne : colonneDaEsito(d.esito);
  const stato = covStato(d);
  const t = TABS.find((x) => x.id === tab) || TABS[0];
  const isRiep = tab === 'RIEPILOGO';
  const keys = t.keys || [];
  const groups = isRiep
    ? RIEP_GRUPPI.map((g) => ({ id: g.id, keys: g.keys.filter((k) => (colonne[k] || {}).esito === 'OK') })).filter((g) => g.keys.length)
    : [{ id: t.id, keys }];
  const totale = groups.reduce((n, g) => n + g.keys.length, 0);

  const statoMsg = stato === 'errore' ? 'Verifica non riuscita. Riprova.'
    : stato === 'nontrovato' ? 'Indirizzo non trovato su SSMATE'
      : 'Indirizzo trovato · Copertura SSMATE';
  const statoCol = stato === 'ok' ? '#86efac' : stato === 'errore' ? '#fca5a5' : '#fbbf24';

  return (
    <div>
      {d.indirizzo && (d.indirizzo.comune || d.indirizzo.via) && (
        <div style={{ fontWeight: 700, color: '#fff', textTransform: 'capitalize', marginBottom: 2, fontSize: 13.5 }}>
          {(d.indirizzo.comune || '').toLowerCase()} · {(d.indirizzo.via || '').toLowerCase()} {d.indirizzo.civico || ''}
        </div>
      )}
      <div style={{ fontSize: 12, color: statoCol, marginBottom: 10 }}>{statoMsg}</div>

      {stato === 'ok' && (
        <>
          <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
            {TABS.map((x) => (
              <button key={x.id} type="button" onClick={() => setTab(x.id)} style={{
                flex: 1, padding: '7px 6px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer', borderRadius: 9,
                border: '1px solid ' + (tab === x.id ? 'rgba(20,184,166,.6)' : 'rgba(255,255,255,.14)'),
                background: tab === x.id ? 'rgba(20,184,166,.16)' : 'rgba(255,255,255,.05)',
                color: tab === x.id ? '#5eead4' : 'rgba(255,255,255,.6)',
              }}>{x.id}</button>
            ))}
          </div>
          <div style={{ height: 236, overflowY: 'auto' }}>
          {totale === 0 ? (
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,.55)' }}>{isRiep ? 'Nessuna tecnologia vendibile su questo indirizzo.' : 'Nessun dato in questa sezione.'}</div>
          ) : (
            <div style={isRiep ? { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 22px', alignItems: 'start' } : undefined}>
              {groups.map((g) => (
                <div key={g.id}>
                  {isRiep && (
                    <div style={{ fontSize: 10.5, fontWeight: 800, letterSpacing: '.6px', textTransform: 'uppercase', color: '#5eead4', background: 'rgba(20,184,166,.12)', border: '1px solid rgba(20,184,166,.4)', borderRadius: 8, padding: '5px 9px', margin: '0 0 6px' }}>{g.id}</div>
                  )}
                  {g.keys.map((k) => { const c = COLS.find((x) => x.k === k) || { l: LABEL[k] }; return (
                    <div key={k} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 2px', borderBottom: '1px solid rgba(255,255,255,.07)', fontSize: 13 }}>
                      <span style={{ color: 'rgba(255,255,255,.7)' }}>{c.l}</span>
                      <span>{cell(c, colonne[k])}</span>
                    </div>
                  ); })}
                </div>
              ))}
            </div>
          )}
          {!d.colonne && !isRiep && <div style={{ fontSize: 11, color: 'rgba(255,255,255,.4)', marginTop: 8 }}>Riepilogo da verifica precedente: dettaglio velocità/fascia non disponibile.</div>}
          </div>
        </>
      )}
    </div>
  );
}
